export default __webpack_public_path__ + "static/media/illustration.12854c8d.jpg";